@if (available) {
  <div class="ff-panel" [class.ff-panel-off]="!overlayOn" data-test="ff-debug-panel">
    <div class="ff-panel-header">
      <label class="ff-panel-switch" title="Show GrowthBook flag ids (Alt+Shift+F)">
        <input
          type="checkbox"
          role="switch"
          data-test="ff-debug-toggle"
          aria-label="Show GrowthBook flag ids"
          [checked]="overlayOn"
          (change)="setOverlay($any($event.target).checked)" />
        <span class="ff-panel-slider"></span>
      </label>
      @if (failOpen) {
        <span
          class="ff-panel-fail-open"
          data-test="ff-debug-fail-open"
          title="GrowthBook is unavailable — every feature flag is treated as ON">
          FAIL-OPEN
        </span>
      }
      @if (overlayOn) {
        <button
          type="button"
          class="ff-panel-toggle"
          data-test="ff-debug-expand"
          (click)="toggle()">
          flags ({{ flags.length }}) {{ expanded ? '▾' : '▴' }}
        </button>
      }
    </div>
    @if (overlayOn && expanded) {
      <div class="ff-panel-body">
        <input
          class="ff-panel-filter"
          placeholder="Filter…"
          [value]="filterText"
          (input)="onFilter($event)" />
        <ul>
          @for (flag of filteredFlags; track flag) {
            <li (click)="copy(flag)" title="Click to copy">
              {{ flag }}
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
